import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import CardActivityListPage from 'apps/auth/pages/ga/CardActivityListPage';
import CardDetailsPage from 'apps/auth/pages/ga/CardDetailsPage';
import CardLimitsPage from 'apps/auth/pages/ga/CardLimitsPage';
import CardsGAPage from 'apps/auth/pages/ga/CardsGAPage';
import ExpiredNotificationPage from 'apps/auth/pages/ga/ExpiredNotificationPage';
import GetVirtualPage from 'apps/auth/pages/ga/GetVirtualPage';
import GetVirtualPreviewPage from 'apps/auth/pages/ga/GetVirtualPreviewPage';
import MultiCurrencyPage from 'apps/auth/pages/ga/MultiCurrencyPage';
import NeedPinPage from 'apps/auth/pages/ga/NeedPinPage';

const gaAuthCard = [
    {
        path: '/auth/ga/cards/order/virtual/preview',
        component: GetVirtualPreviewPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/cards/order/virtual',
        component: GetVirtualPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/cards/order/preview',
        component: MultiCurrencyPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/cards/plastic/:cardId/need/pin',
        component: NeedPinPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },

    {
        path: '/auth/ga/cards',
        component: CardsGAPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            isGA: true,
        },
    },
    {
        path: '/auth/ga/card/:cardId/activity',
        component: CardActivityListPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: 'bundle',
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/card/:cardId/atm-limits',
        component: CardLimitsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/card/expired/notification',
        component: ExpiredNotificationPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: ['/auth/ga/card/:cardId'],
        component: CardDetailsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
];
export default gaAuthCard;
